webpackJsonp([35783957827783],{

/***/ 109:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Experience = function Experience() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'container mt-5 mb-5', id: 'experience' },
	    _react2.default.createElement(
	      'div',
	      { className: 'experience-grid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'experience-column' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Experience'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'experience-list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'Datadog'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Design Manager // Senior Product Designer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'NGINX'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Design Manager // Senior Product Designer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'New Engen'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Designer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'Freelance'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Designer'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/Matt Harris Resume.pdf', download: 'Matt Harris Resume.pdf', className: 'download-resume-btn' },
	          _react2.default.createElement(
	            'svg',
	            { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M12 16L12 8', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	            _react2.default.createElement('path', { d: 'M8 12L12 16L16 12', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	            _react2.default.createElement('path', { d: 'M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	          ),
	          'Download Resume'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'selected-works-column' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Selected Works'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'selected-works-list' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/manage-ai-cost-and-performance-with-datadog/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/manage-ai-cost-and-performance-with-datadog/datadog-ai-costs-hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Manage AI Cost and Performance'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/cloud-cost-management-finops/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/cloud-cost-management-finops/cloud-cost-management-finops-hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Cloud Cost Management for FinOps'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/cloud-cost-recommendations/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/cloud-cost-recommendations/cloud-cost-recommendations-hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Cloud Cost Recommendations'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/dashboards-notebooks-version-history/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/dashboards-notebooks-version-history/version-history_hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Dashboards & Notebooks Version History'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Experience;
	module.exports = exports['default'];

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _WorkItem = __webpack_require__(13);
	
	var _WorkItem2 = _interopRequireDefault(_WorkItem);
	
	var _datadogLogo = __webpack_require__(117);
	
	var _datadogLogo2 = _interopRequireDefault(_datadogLogo);
	
	var _instanceExplorer = __webpack_require__(65);
	
	var _instanceExplorer2 = _interopRequireDefault(_instanceExplorer);
	
	var _cloudCostManagementHero = __webpack_require__(63);
	
	var _cloudCostManagementHero2 = _interopRequireDefault(_cloudCostManagementHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Work = function Work() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'container mb-5 pb-5', id: 'work' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'col-sm' },
	          'Current Work'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row mb-4' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 mb-4 mb-md-0' },
	          _react2.default.createElement(_WorkItem2.default, { href: 'https://www.datadoghq.com/product/cloud-cost-management/', title: 'Cloud Cost Management', image: _cloudCostManagementHero2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 mb-4 mb-md-0' },
	          _react2.default.createElement(_WorkItem2.default, { href: 'https://instances.datadoghq.com/', title: 'Instance Explorer', image: _instanceExplorer2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/past-work/', style: { color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none', fontSize: '1rem' } },
	            'View All Work \u2192'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Work;
	module.exports = exports['default'];

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cloud-cost-management-hero.5ee32991.png";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/datadog-logo.feb3d97f.png";

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-image.398994dc.jpg";

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/instance-explorer.6567c9ba.jpg";

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsCookie = __webpack_require__(46);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _Hero = __webpack_require__(11);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Work = __webpack_require__(82);
	
	var _Work2 = _interopRequireDefault(_Work);
	
	var _Experience = __webpack_require__(166);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _constants = __webpack_require__(37);
	
	var _heroImage = __webpack_require__(119);
	
	var _heroImage2 = _interopRequireDefault(_heroImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    _jsCookie2.default.set(_constants.PATH_PREFIX_COOKIE, '');
	  };
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Hero2.default,
	        { portrait: _heroImage2.default, portraitAlt: 'Matt Harris presenting', showScrollIndicator: true },
	        _react2.default.createElement(
	          'h1',
	          { className: 'stylized-name' },
	          _react2.default.createElement(
	            'span',
	            { className: 'name-matt' },
	            'Matt'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'name-harris' },
	            'Harris'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'index-subtitle' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Product designer & manager'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Based in San Francisco'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Currently @ ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://datadoghq.com/', target: '_blank' },
	              'Datadog'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'social-links' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/matthewzharris/', target: '_blank', rel: 'noopener noreferrer', 'aria-label': 'LinkedIn' },
	            _react2.default.createElement(
	              'svg',
	              { viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
	              _react2.default.createElement('path', { d: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' })
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.figma.com/@matthewzharris', target: '_blank', rel: 'noopener noreferrer', 'aria-label': 'Figma' },
	            _react2.default.createElement(
	              'svg',
	              { viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
	              _react2.default.createElement('path', { d: 'M15.852 8.981h-4.588V0h4.588c2.476 0 4.49 2.014 4.49 4.49s-2.014 4.491-4.49 4.491zM12.735 7.51h3.117c1.665 0 3.019-1.355 3.019-3.019s-1.355-3.019-3.019-3.019h-3.117V7.51zm0 1.471H8.148c-2.476 0-4.49-2.014-4.49-4.49S5.672 0 8.148 0h4.588v8.981zm-4.587-7.51c-1.665 0-3.019 1.355-3.019 3.019s1.355 3.019 3.019 3.019h3.117V1.471H8.148zm4.587 15.019H8.148c-2.476 0-4.49-2.014-4.49-4.49s2.014-4.49 4.49-4.49h4.588v8.98zM8.148 8.981c-1.665 0-3.019 1.355-3.019 3.019s1.355 3.019 3.019 3.019h3.117V8.981H8.148zM8.172 24c-2.489 0-4.515-2.014-4.515-4.49s2.014-4.49 4.49-4.49h4.588v4.441c0 2.503-2.047 4.539-4.563 4.539zm-.024-7.51a3.023 3.023 0 0 0-3.019 3.019c0 1.665 1.365 3.019 3.044 3.019 1.705 0 3.093-1.376 3.093-3.068v-2.97H8.148zm7.704 0h-.098c-2.476 0-4.49-2.014-4.49-4.49s2.014-4.49 4.49-4.49h.098c2.476 0 4.49 2.014 4.49 4.49s-2.014 4.49-4.49 4.49zm-.098-7.509c-1.665 0-3.019 1.355-3.019 3.019s1.355 3.019 3.019 3.019h.098c1.665 0 3.019-1.355 3.019-3.019s-1.355-3.019-3.019-3.019h-.098z' })
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/matthewzharris', target: '_blank', rel: 'noopener noreferrer', 'aria-label': 'GitHub' },
	            _react2.default.createElement(
	              'svg',
	              { viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
	              _react2.default.createElement('path', { d: 'M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Work2.default, null),
	      _react2.default.createElement(_Experience2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-3e50fa8ece542ce65a7c.js